import { useEffect, useState } from 'react';

import { format, getSeconds, secondsToMilliseconds } from 'date-fns';

import { TZDate } from '@date-fns/tz';

export const useGetTime = (tzCode: string) => {
  const [intervalTimeOut, setIntervalTimeout] = useState<number | null>(null);
  const [date, setDate] = useState(
    format(new TZDate(Date.now(), tzCode), 'HH:mm'),
  );

  useEffect(() => {
    const interval = setInterval(
      () => {
        setDate(format(new TZDate(Date.now(), tzCode), 'HH:mm'));
        setIntervalTimeout(intervalTimeOut ?? secondsToMilliseconds(60));
      },
      intervalTimeOut ?? secondsToMilliseconds(60 - getSeconds(Date.now())),
    );

    return () => {
      clearInterval(interval);
    };
  }, [intervalTimeOut]);

  return {
    date,
  };
};
